module.exports = __webpack_public_path__ + "img/qr-privacy.e75e5236.png";